import styles from "./UploadGridItem.module.css";
import ElementsContextType from "../../types/ElementsContextType";
import { ElementsContext } from "../contexts/ElementsContext";
import { useSelector } from "react-redux";
import React from "react";
import { AssetState } from "../../types/AssetState";

interface IDictionary {
    [index: string]: string;
}

const styleList = {
    small: styles.docSmall,
    medium: styles.docMedium,
    large: styles.docLarge,
    remaining: styles.docRemaining
} as IDictionary;

interface Props {
    type: string;
    components?: any;
    remaining?: string;
    id: number;
    elementId: string;
}

export default function UploaderForDocuments({
    type,
    components,
    remaining,
    id,
    elementId
}: Props) {
    const { openGallery, openImageViewer } = React.useContext(
        ElementsContext
    ) as ElementsContextType;
    const currentElement = useSelector((state: any) =>
        state.portal.activeInspection.sections.find(
            (section: any) => section.Id === elementId
        )
    );
    const documentElement = currentElement.Documents[id];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const uploadList = useSelector((state: any) =>
        state.portal.uploadList.get(documentElement.id)
    );

    function clickHandler() {
        if (remaining?.length && currentElement) {
            openGallery(currentElement);
        } else if (currentElement) {
            openImageViewer(documentElement, currentElement);
        }
    }

    const selectedStyle = styleList[type];
    const gridItemState =
        documentElement.state !== undefined
            ? documentElement.state
            : AssetState.NO_ASSET;
    const uploadProgress =
        documentElement?.progress !== undefined ? documentElement.progress : 0;

    const componentProps = {
        clickHandler: clickHandler,
        uploadProgress: uploadProgress,
        selectedStyle: selectedStyle,
        displayStyle: type,
        element: currentElement,
        document: documentElement,
        remaining: remaining
    };

    const gridItem = React.createElement(
        components[gridItemState],
        componentProps
    );

    return (
        <div className={styles.documentGridItems}>
            <div>{gridItem}</div>
        </div>
    );
}
